exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.text-title {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow:ellipsis;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/_shared/nav/nav-node.component.css
// module id = 741
// module chunks = 0